/**
 * DynamicNoteForm: the "edit form" for no-config dynamic blocks.
 *
 * Used for `graph-preview`: this block renders live platform data and has an
 * empty `{}` data contract: there is nothing to author. Rather than show a
 * blank panel, this component displays a short explanatory note so the admin
 * understands the block is intentionally config-free.
 *
 * It accepts `onChange` for a uniform form interface but never calls it.
 */
import React from 'react';
import PropTypes from 'prop-types';
import { Alert } from 'react-bootstrap';

export default function DynamicNoteForm({ note }) {
    return (
        <Alert variant="info" className="mb-0">
            {note}
        </Alert>
    );
}

DynamicNoteForm.propTypes = {
    // The explanatory text shown to the admin.
    note: PropTypes.string.isRequired,
    // Present for a uniform form interface; intentionally unused.

    onChange: PropTypes.func,

    data: PropTypes.object,
};

DynamicNoteForm.defaultProps = {
    onChange: undefined,
    data: {},
};
